// extracted by mini-css-extract-plugin
export default {"authCard":"auth-card_authCard__CnBh7","form":"auth-card_form__UMaUz"};